module.exports = __webpack_public_path__ + "img/Выписка-из-реестра-на-деятельность-по-обороту-НС-и-ПВ_Page_2.53d4eedd.jpg";